var _path;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcoPause(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 8,
    height: 12,
    viewBox: "0 0 8 12",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.08995 0.871318L5.08996 11.2941L6.39791 11.2941C7.12121 11.2941 7.70587 10.9835 7.70587 10.5993L7.70587 0.176465L6.39791 0.176465C5.67461 0.176465 5.08995 0.487759 5.08995 0.871318ZM3.12802 10.5993C3.12802 10.9835 2.54336 11.2941 1.82006 11.2941L0.512101 11.2941L0.5121 0.871319C0.5121 0.48776 1.09676 0.176467 1.82006 0.176467L3.12802 0.176466L3.12802 10.5993Z",
    fill: "#0072C9"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcoPause);
export default __webpack_public_path__ + "static/media/ico_pause.fc1829b1bf72828b9a962f3d23a27855.svg";
export { ForwardRef as ReactComponent };